import styles from "@/features/widget-forms/forms/weather-model-map/weather-model-map-dialog.module.css";

import { ObservationsMapDisplayGroupSection } from "./observations-map-display-group-section";
import { ObservationsMapStationLocationFilterPanel } from "./observations-map-station-location-filter-panel";
import { ObservationsMapWeatherStationsEnabledPanel } from "./observations-map-weather-stations-enabled-panel";

export function ObservationsMapMarkerDesignsTab() {
  return (
    <>
      <div className={styles.settingsPanel}>
        <ObservationsMapWeatherStationsEnabledPanel />
        <ObservationsMapStationLocationFilterPanel />
      </div>
      <ObservationsMapDisplayGroupSection showSectionTitle />
    </>
  );
}
